import { Floor } from '../model/types';

export const sortFloorsByOrder = (floors: Floor[]): Floor[] => {
  return [...floors].sort((a, b) => a.order - b.order);
};
